import { replaceRule } from '@/utils/data'
import { QuestionCircleOutlined } from '@ant-design/icons'
import { Tooltip } from 'antd'
import { STags } from 'shj-components'

export const config = {
  fieldControl: false,
  searchTypeWidth: 150, // 搜索框宽度
  search: [
    {
      label: '标配SKU名称',
      name: 'productSkuNameKey',
    },
    { label: '标配SKU_ID', name: 'productSkuId' },
    {
      label: '适用门店',
      name: 'orgId',
      itemType: 'select',
      data: 'companyList',
      labelKey: 'name',
      key: 'id',
    },
    {
      label: '适用产品',
      name: 'applyProdId',
      labelProps: { width: 120 },
      itemType: 'custom',
      render: 'productRender',
    },
  ],
  columns: [
    { title: '序号', dataIndex: 'orderNumber', width: 80 },
    { title: '标配SKU名称', dataIndex: 'showName', width: 200 },
    { title: '标配SKU_ID', dataIndex: 'productSkuId', width: 200 },
    { title: '适用产品', dataIndex: 'applyProdName', width: 120 },
    {
      title: (
        <span>
          适用门店
          <Tooltip title="标配的适用门店">
            <QuestionCircleOutlined style={{ marginLeft: 5 }} />
          </Tooltip>
        </span>
      ),
      dataIndex: 'orgName',
      width: 120,
    },
    {
      title: 'SKU适用门店',
      dataIndex: ['productSku', 'shops'],
      width: 150,
      ellipsis: {
        showTitle: true,
      },
      render: v => {
        return v ? v.map(item => item?.companyName).join('，') : ''
      },
    },
    { title: '产品类型', dataIndex: 'prodTypeName', width: 120 },
    {
      title: 'SKU状态',
      dataIndex: 'skuEnabled',
      width: 120,
      render: (text: any, record: any) => {
        return (
          <STags
            itemKey=""
            label={text ? '启用' : '禁用'}
            fontColor={text ? '#00A865' : '#EB3723'}
            bgColor={text ? '#D7F7EA' : '#FFEAE8'}
          />
        )
      },
    },
    {
      title: '是否必选',
      dataIndex: 'requiredFlag',
      width: 120,
      render: (text: any, record: any) => {
        return text ? '是' : '否'
      },
    },
    {
      title: '预算量规则',
      dataIndex: ['standardJson', 'budgetRule'],
      width: 150,
      render: (text: any, record: any) => {
        return text ? replaceRule(text) : ''
      },
    },
    {
      title: '是否可编辑量',
      dataIndex: 'editFlag',
      width: 160,
      render: (text: any, record: any) => {
        return text ? '是' : '否'
      },
    },
    { title: '开始日期', dataIndex: 'startDate', width: 120, itemType: 'date' },
    { title: '结束日期', dataIndex: 'endDate', width: 120, itemType: 'date' },
    { title: '操作', dataIndex: '#', width: 120, fixed: 'right', render: 'actionRender' },
  ],
  footer: [
    { label: '下载', render: 'exportRender' },
    { label: '导入', render: 'importRender' },
    { label: '新增配置', type: 'primary', events: ['onClick:onAdd'] },
  ],
  batchActions: [{ label: '删除', danger: true, events: ['onClick:onBatchDelete'] }],
}
